<template>
   <div class="transfer-datepicker-container g-input-container">
      <label>{{ label }}</label>
      <div class="transfer-datepicker-input-wrapper">
         <!-- From Date -->
         <div class="date-wrapper" @click="handlerShowDatePicker('from')" :class="{ activedate: datepickers.from.status }">
            <span class="day">{{ DisplayFromDate.day }}</span>
            <div class="month-year-wrapper">
               <span class="month">{{ DisplayFromDate.month }}</span>
               <span class="year">{{ DisplayFromDate.year }}</span>
            </div>
            <!-- <div class="to-date-clear-button-wrapper">
               <i class="gts-icon icon-close-rounded icon-xs" @click="datepickers.from.value = today"></i>
            </div> -->
         </div>

         <!-- Return Date -->
         <div class="date-wrapper" @click="handlerShowDatePicker('to')" :class="{ activedate: datepickers.to.status }">
            <template v-if="DisplayToDate.year.length == 4">
               <span class="day">{{ DisplayToDate.day }}</span>
               <div class="month-year-wrapper">
                  <span class="month">{{ DisplayToDate.month }}</span>
                  <span class="year">{{ DisplayToDate.year }}</span>
               </div>
            </template>
            <template v-else>
               <div class="add-return-date">+</div>
            </template>
         </div>
         <div class="to-date-clear-button-wrapper gts-animation me-0 d-xxl-flex" v-if="DisplayToDate.year.length == 4">
            <i class="gts-icon icon-close-rounded icon-xs" @click="handlerClearFromDate"></i>
         </div>
      </div>
      <!-- Datepicker   -->

      <div class="g-datepicker-wrapper" :class="identifier">
         <!-- <b-datepicker inline v-model="datepickers.vModel" @input="handlerDatePickerChange"> </b-datepicker> -->
         <UIDatePickerWithTime
            v-model="datepickers.model"
            inline
            ref="datePicker"
            :min="minDate"
            :max="maxDate"
            custom-header
            with-time
            :controls="fmt"
            :identifier="identifier"
            @time-update="handlerTimeUpdate"
            @apply="handlerApply" />
      </div>
   </div>
</template>

<script>
import moment from "moment";
import i18n from "@/fmt/i18n.js";
import UIDatePickerWithTime from "@/components/unitary/form2/UIDatePickerWithTime.vue";
export default {
   name: "TransferDatePicker",
   props: {
      label: String,
      searchQuery: Object,
   },
   components: {
      UIDatePickerWithTime,
   },
   data() {
      return {
         identifier: "",
         minDate: moment().add(1, "days").format(this.$constants.dateFormat),
         maxDate: moment().add(1, "years").format(this.$constants.dateFormat),
         datepickers: {
            model: moment().add(1, "days").format(this.$constants.dateFormat),

            from: {
               status: false,
               value: moment().add(1, "days").format(this.$constants.dateFormat),
            },
            to: {
               status: false,
               value: "",
            },
            monthArr: [],
         },
         times: {
            from: "00:00",
            to: "00:00",
         },
      };
   },
   computed: {
      fmt() {
         const LABELS = {
            DEPARTURE: this.$i18n.t("transferDatePicker_lblFlightDeparture"),
            LANDING: this.$i18n.t("transferDatePicker_lblFlightLanding"),
            PICKUP: this.$i18n.t("transferDatePicker_lblPickup"),
            RETURN: this.$i18n.t("transferDatePicker_lblReturn"),
         };

         const fromAirport = this.searchQuery.from.locationType === 9;
         const toAirport = this.searchQuery.to.locationType === 9;
         const hasReturn = !!this.searchQuery.returnDate;
         const id = this.identifier;

         // OUTBOUND
         if (id === "from") {
            if (!fromAirport && toAirport) return { label: LABELS.DEPARTURE };
            if (fromAirport && !toAirport) return { label: LABELS.LANDING };
            if (!fromAirport && !toAirport) return { label: LABELS.PICKUP };
            if (fromAirport && toAirport) return { label: LABELS.LANDING };
         }

         // RETURN (reverse direction)
         if (id === "to" && hasReturn) {
            if (!toAirport && fromAirport) return { label: LABELS.DEPARTURE };
            if (toAirport && !fromAirport) return { label: LABELS.LANDING };
            if (!toAirport && !fromAirport) return { label: LABELS.RETURN };
            if (toAirport && fromAirport) return { label: LABELS.DEPARTURE };
         }

         return { label: null };
      },

      DisplayFromDate() {
         const value = this.datepickers.from.value;

         return {
            day: moment(value, this.$constants.dateFormat).lang(i18n.locale).format("DD"),
            month: moment(value, this.$constants.dateFormat).lang(i18n.locale).format("MMMM"),
            year: moment(value, this.$constants.dateFormat).lang(i18n.locale).format("YYYY"),
         };
      },
      DisplayToDate() {
         const value = this.datepickers.to.value;

         if (moment(value).isValid()) {
            return {
               day: moment(value, this.$constants.dateFormat).lang(i18n.locale).format("DD"),
               month: moment(value, this.$constants.dateFormat).lang(i18n.locale).format("MMMM"),
               year: moment(value, this.$constants.dateFormat).lang(i18n.locale).format("YYYY"),
            };
         } else {
            return {
               day: "",
               month: "",
               year: "",
            };
         }
      },
   },

   methods: {
      handlerTimeUpdate(time) {
         const key = time.identifier || "from";
         this.times[key] = time.value;
         const dateOnly = this.datepickers[key].value.split("T")[0];
         this.datepickers[key].value = moment(`${dateOnly} ${time.value}`, "YYYY-MM-DD HH:mm").format(this.$constants.dateTimeFormat);
         this.$emit("date-update", {
            from: this.datepickers.from.value,
            to: this.datepickers.to.value.length != 0 ? this.datepickers.to.value : null,
         });
      },
      handlerApply() {
         this.$refs.datePicker.datepicker.status = false;
         this.datepickers.from.status = false;
         this.datepickers.to.status = false;
      },
      handlerClearFromDate() {
         this.datepickers.to.value = "";
         this.$emit("date-update", {
            from: this.datepickers.from.value,
            to: null,
         });
         this.maxDate = moment().add(1, "years").format(this.$constants.dateFormat);
      },
      handlerClickOutside() {
         this.$refs.datePicker.datepicker.status = false;
         this.datepickers.from.status = false;
         this.datepickers.to.status = false;
      },
      handlerShowDatePicker(identifier) {
         this.$refs.datePicker.datepicker.status = true;
         this.identifier = identifier;
         this.datepickers[identifier].status = true;
         if (identifier == "from" && this.datepickers.to.value.length != 0) {
            this.minDate = moment().add(1, "days").format(this.$constants.dateFormat);
            this.maxDate = this.datepickers.to.value.split("T")[0];
            this.datepickers.model = this.datepickers.from.value.split("T")[0];
         }
         if (identifier == "to" && this.datepickers.from.value.length != 0) {
            this.minDate = this.datepickers.from.value.split("T")[0];
            this.maxDate = moment().add(1, "years").format(this.$constants.dateFormat);
            this.datepickers.to.value.length != 0 ? (this.datepickers.model = this.datepickers.to.value.split("T")[0]) : null;
         }
         this.datepickers[identifier === "from" ? "to" : "from"].status = false;
      },
      handlerDatePickerChange() {
         if (this.datepickers.from.status) {
            this.datepickers.from.value = moment(`${this.datepickers.model} ${this.times.from}`, "YYYY-MM-DD HH:mm").format(this.$constants.dateTimeFormat);
         }
         if (this.datepickers.to.status) {
            this.datepickers.to.value = moment(`${this.datepickers.model} ${this.times.to}`, "YYYY-MM-DD HH:mm").format(this.$constants.dateTimeFormat);
         }

         this.$emit("date-update", {
            from: this.datepickers.from.value,
            to: this.datepickers.to.value.length != 0 ? this.datepickers.to.value : null,
         });
      },
   },
   watch: {
      "datepickers.model": {
         handler: function () {
            this.handlerDatePickerChange();
         },
      },
      "datepickers.to.status": {
         handler: function (status) {
            if (status && this.datepickers.to.value.length == 0) {
               this.datepickers.to.value = this.datepickers.model;
            }
            this.$emit("date-update", {
               from: this.datepickers.from.value,
               to: this.datepickers.to.value,
            });
         },
         deep: true,
      },
   },
};
</script>

<style lang="scss" scoped>
.transfer-datepicker-container {
   .transfer-datepicker-input-wrapper {
      width: 100%;
      height: 48px;
      color: var(--gray-700);
      background: var(--gray-100);
      text-transform: capitalize;
      border: 1px solid var(--gray-300);
      border-radius: 0.5rem;
      display: flex;
      justify-content: space-around;
      position: relative;
      overflow: hidden;

      &:after {
         content: "";
         position: absolute;

         top: 0.5rem;
         margin: auto;
         display: flex;
         bottom: 0.5rem;
      }

      .date-wrapper {
         cursor: pointer;
         display: flex;
         align-items: center;
         width: 100%;
         justify-content: center;
         margin-top: 0.25rem;
         margin-bottom: 0.25rem;

         &:hover {
            span {
               color: var(--accent-primary);
            }
         }

         span {
            &.day {
               font-size: var(--xxlarge);
               font-weight: 600;
            }
         }

         .month-year-wrapper {
            line-height: 14px;
            display: flex;
            flex-direction: column;
            padding-left: 0.25rem;
            margin-right: 0.75rem;
            span {
               font-size: var(--xsmall);
               font-weight: 500;
            }
         }

         &:first-child {
            margin-left: 0.5rem;
            margin-right: 0.25rem;
            border-right: 1px solid var(--gray-300);
         }

         &:last-child {
            margin-left: 0.15rem;
            margin-right: 0.65rem;
         }

         .add-return-date {
            cursor: pointer;
            padding: 0.125rem 0.75rem;
            background: var(--gray-200);
            border: 1px dashed var(--gray-400);
            border-radius: 0.5rem;
            color: var(--gray-400);
            font-size: 2rem;
            font-weight: 300;
            line-height: 28px;
            text-align: center;
         }

         &.activedate {
            span {
               color: var(--accent-primary);
            }
         }
      }
      .to-date-clear-button-wrapper {
         position: absolute;
         right: 3px;
         padding: 0.125rem;
         cursor: pointer;
         top: 12px;
         @media (max-width: 992px) {
            right: 1rem;
         }
      }
   }
   .g-datepicker-wrapper {
      &.to {
         margin-left: 120px;
         @media (max-width: 576px) {
            margin-left: 0;
         }
      }
      &.from {
         margin-left: -187px;

         @media (max-width: 992px) {
            margin-left: 0;
         }
      }
   }
}
</style>
